import React from "react";
import { useSelector } from "react-redux";
import godtvLoader from "../../assets/Images/godtv_loader.png";

const Loading = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const theme = projectInfo?.projectConfig?.config?.THEME;
  const template = projectInfo?.projectConfig?.config?.TEMPLATE;

  return (
    <div className="loadingContainer">
      <div className="loading">
        <div className="loadingOverlay"></div>
        {template === "TEMPLATE_12" && projectInfo?.projectConfig?.pubid === 50174 ? (
          <img src={godtvLoader} alt="Loading" className="loading-logo-pulse" />
        ) : (
          <span className={`loader-spinner ${theme === "LIGHT" ? "light" : ""}`}></span>
        )}
      </div>
    </div>
  );
};

export default Loading;
